<template>
  <div class="app-container" style="background: rgb(217, 236, 255); background-size: cover; height: 100%;">
    <div v-if="isMobile === false">
      <el-card class="box-card" style="width: 80%; margin: 10px auto; margin-top: 60px;">
        <div style="margin-top: 20px; text-align: center;">
          <img :src="this.$route.params.originShopLogoUrl + '?imageView2/0/w/360/h/180/q/75|imageslim'" style="width: 200px;">
          <p style="font-size: 24px;">
            <span>{{ this.$route.params.originShopName }}</span>
            — 代理商自助申请</p>
        </div>
      </el-card>
      <el-card class="box-card" style="width: 80%; margin: 20px auto;">
        <div style="padding: 0 100px; margin-top: 30px;">
          <i class="el-icon-success" style="color: #67C23A; font-size: 28px;" />
          <span style="color: #67C23A; font-size: 28px;">恭喜注册成功！</span>
        </div>
        <div style="padding: 30px 100px; font-size: 18px; line-height: 36px;">
          <div style="">登录链接：
            <a :href="agentAdminUrl" target="_blank" style="text-decoration:underline; color: #409EFF;">
              {{ agentAdminUrl }}
            </a>
            <el-button type="primary" plain @click="toLogin()" style="margin-left: 20px;">去登录</el-button>
          </div>
          <div>登录账号：
            <span style="color: #409EFF;">{{ this.$route.params.username }}</span>
          </div>
          <div style="font-size: 14px; color: red; margin-top: 10px;">*请保存好登录账号和登录链接</div>
        </div>
      </el-card>
    </div>
    <div v-else>
      <el-card class="box-card" style="width: 95%; margin: 10px auto; margin-top: 30px;">
        <div style="margin-top: 20px; text-align: center;">
          <img :src="this.$route.params.originShopLogoUrl + '?imageView2/0/w/360/h/180/q/75|imageslim'" style="width: 130px;">
          <p style="font-size: 16px;">
            <span>{{ this.$route.params.originShopName }}</span>
            — 代理商自助申请</p>
        </div>
      </el-card>
      <el-card class="box-card" style="width: 95%; margin: 20px auto;">
        <div style="padding: 0 20px; margin-top: 20px;">
          <i class="el-icon-success" style="color: #67C23A; font-size: 22px;" />
          <span style="color: #67C23A; font-size: 22px;">恭喜注册成功！</span>
        </div>
        <div style="padding: 10px 20px; font-size: 16px; line-height: 36px;">
          <div>登录链接：
            <a :href="agentAdminUrl" target="_blank" style="text-decoration:underline; color: #409EFF;">
              {{ agentAdminUrl }}
            </a>
            <el-button type="primary" plain size="small" @click="toLogin()">去登录</el-button>
          </div>
          <div>登录账号：
            <span style="color: #409EFF;">{{ this.$route.params.username }}</span>
          </div>
          <div style="font-size: 14px; color: red;">*请保存好登录账号和登录链接</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// import request from '@/utils/request'

export default {
  name: 'ApplicationSuccess',
  data() {
    return {
      agentAdminUrl: process.env.VUE_APP_AGENT_URL,
      isMobile: false,
      username: '',
      origin_shop_id: '',
      origin_shop_name: '',
      origin_shop_logo_url: ''
    }
  },
  computed: {
    displayLogoUrl() {
      return (
        this.agentForm.shop_logo_url +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  },
  created() {
    if (!this.$route.params.originShopName) {
      this.$router.push({
        name: '404'
      })
    }
    this.checkMobile()
  },
  methods: {
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    toLogin() {
      const { href } = this.$router.resolve({
        path: '/login',
        query: {
          username: this.$route.params.username
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
